export default __webpack_public_path__ + "static/media/sleep.a75be08c.svg";